import { cpf, cnpj } from "cpf-cnpj-validator";

const mixin = {
  methods: {
    isValidCPF: function(document) {
      return cpf.isValid(document);
    },
    isValidCNPJ: function(document) {
      return cnpj.isValid(document);
    },
    isAlpha: function(value) {
      return /^[A-zÀ-ú. ]*$/.test(value);
    },
    isValidDate: function(date) {
      return /^([0-2]\d|3[0-1])\/(0\d|1[0-2])\/[1-2]\d{3}$/.test(date);
    }
  }
}

export default mixin;